import CustomTable from "./Table.js";
const columns = [
    {
        title: "Hotel ID",
        dataIndex: "id",
        key: "id",
        sorter: () => {},
    },
    {
        title: "Hotel Name",
        dataIndex: "name",
        key: "name",
        sorter: () => {},
    },
    {
        title: "Street",
        dataIndex: "street",
        key: "street",
        sorter: () => {},
    },
    {
        title: "City",
        dataIndex: "city",
        key: "city",
        sorter: () => {},
    },
    {
        title: "State",
        dataIndex: "state",
        key: "state",
        sorter: () => {},
    },
    {
        title: "Zipcode",
        dataIndex: "zipcode",
        key: "zipcode",
        sorter: () => {},
    },
];

function HotelList({
    tableData,
    id,
    noOfrecords,
    handlePageChange,
    currentPage,
    currentPageLimit,
    site = undefined,
}) {
    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        others.site = site;
        handlePageChange({ key: id, ...others });
    }

    return (
        <CustomTable
            columns={columns}
            tableData={tableData}
            noOfrecords={noOfrecords}
            handleTableChange={handleTableChange}
            rowKey="id"
            className="dashboard-table"
            currentPage={currentPage}
            currentPageLimit={currentPageLimit}
            isScroll
        />
    );
}

export default HotelList;
